import { memo, ReactNode } from "react";
import { FiX } from "react-icons/fi";
import Button from "./Button";
import { HiOutlineArrowLeft } from "react-icons/hi";

const AppModalHeader = ({
  title,
  onClose,
  closeBtn,
  label,
  buttonShow,
  containerClassName,
  labelClassName,
  cancelClassName,
}) => {
  return (
    <div
      className={`flex justify-between gap-3 p-4 border-b border-black-10 items-center ${containerClassName} `}
    >
      <p className={`text-base font-semibold text-black-2 ${labelClassName} `}>
        {label}
      </p>
      <div className="hover:bg-[#115B9D]-2 group text-white transition-all rounded-lg cursor-pointer">
        {title}
        {!buttonShow &&
          (closeBtn ? (
            closeBtn
          ) : (
            <FiX
              onClick={onClose}
              className={`ml-auto size-6 group-hover:text-white text-gray-2 ${cancelClassName}`}
            />
          ))}
      </div>
      {buttonShow && (
        <Button
          aria-label="Back"
          onClick={onClose}
          className="bg-white border !border-gray-8  !text-black-2 w-[76px] h-9 flex items-center justify-center hover:bg-[#115B9D]-2/100 hover:!text-white group hover:!border-transparent"
        >
          <HiOutlineArrowLeft className="text-black-2 size-5 group-hover:text-white block mr-1.5" />
          Back
        </Button>
      )}
    </div>
  );
};

export default memo(AppModalHeader);
